// Reddit
import bulkDeleteRedditPostSubmissions from '@/graphql/mutations/posts/bulkDeleteRedditPostSubmissions.gql'
import deleteRedditPostSubmission from '@/graphql/mutations/posts/deleteRedditPostSubmission.gql'
import duplicateRedditPost from '@/graphql/mutations/posts/duplicateRedditPost.gql'
import submitRedditSubmission from '@/graphql/mutations/posts/submitRedditSubmission.gql'
import updateRedditPostSubmissionPostAt from '@/graphql/mutations/posts/updateRedditPostSubmissionPostAt.gql'
// Twitter
import submitTwitterPost from '@/graphql/mutations/twitter/submitTwitterPost.gql'
import deleteTwitterPost from '@/graphql/mutations/twitter/deleteTwitterPost.gql'
import bulkDeleteTwitterPosts from '@/graphql/mutations/twitter/bulkDeleteTwitterPosts.gql'
import rescheduleTwitterPost from '@/graphql/mutations/twitter/rescheduleTwitterPost.gql'
import duplicateTwitterPost from '@/graphql/mutations/twitter/duplicateTwitterPost.gql'
import deleteTwitterSubmission from '@/graphql/mutations/twitter/deleteTwitterSubmission.gql'
import cancelAutoRetweet from '@/graphql/mutations/twitter/cancelAutoRetweet.gql'
import cancelAutoRemove from '@/graphql/mutations/twitter/cancelAutoRemove.gql'
// Instagram
import submitInstagramSubmission from '@/graphql/mutations/instagram/submitInstagramSubmission.gql'
import deleteInstagramPost from '@/graphql/mutations/instagram/deleteInstagramPost.gql'
import rescheduleInstagramSubmission from '@/graphql/mutations/instagram/rescheduleInstagramSubmission.gql'
import duplicateInstagramPost from '@/graphql/mutations/instagram/duplicateInstagramPost.gql'
import bulkDeleteInstagramPosts from '@/graphql/mutations/instagram/bulkDeleteInstagramPosts.gql'
// TikTok
import submitTikTokSubmission from '@/graphql/mutations/tiktok/submitTikTokSubmission.gql'
import duplicateTikTokPost from '@/graphql/mutations/tiktok/duplicateTikTokPost.gql'
import deleteTikTokPost from '@/graphql/mutations/tiktok/deleteTikTokPost.gql'
import bulkDeleteTikTokPosts from '@/graphql/mutations/tiktok/bulkDeleteTikTokPosts.gql'
import rescheduleTikTokSubmission from '@/graphql/mutations/tiktok/rescheduleTikTokSubmission.gql'
// YouTube
import submitYouTubeSubmission from '@/graphql/mutations/youtube/submitYouTubeSubmission.gql'
import duplicateYouTubePost from '@/graphql/mutations/youtube/duplicateYouTubePost.gql'
import deleteYouTubePost from '@/graphql/mutations/youtube/deleteYouTubePost.gql'
import bulkDeleteYouTubePosts from '@/graphql/mutations/youtube/bulkDeleteYouTubePosts.gql'
import rescheduleYouTubeSubmission from '@/graphql/mutations/youtube/rescheduleYouTubeSubmission.gql'
// Bluesky
import submitBlueskyPost from '@/graphql/mutations/bluesky/submitBlueskyPost.gql'
import deleteBlueskyPost from '@/graphql/mutations/bluesky/deleteBlueskyPost.gql'
import bulkDeleteBlueskyPosts from '@/graphql/mutations/bluesky/bulkDeleteBlueskyPosts.gql'
import rescheduleBlueskyPost from '@/graphql/mutations/bluesky/rescheduleBlueskyPost.gql'
import duplicateBlueskyPost from '@/graphql/mutations/bluesky/duplicateBlueskyPost.gql'
import removeSubmissionFromBluesky from '@/graphql/mutations/bluesky/removeSubmissionFromBluesky.gql'
import cancelBlueskyAutoRepost from '@/graphql/mutations/bluesky/cancelBlueskyAutoRepost.gql'
import cancelBlueskyAutoRemove from '@/graphql/mutations/bluesky/cancelBlueskyAutoRemove.gql'
// Tumblr
import submitTumblrSubmission from '@/graphql/mutations/tumblr/submitTumblrSubmission.gql'
import deleteTumblrPost from '@/graphql/mutations/tumblr/deleteTumblrPost.gql'
import bulkDeleteTumblrPosts from '@/graphql/mutations/tumblr/bulkDeleteTumblrPosts.gql'
import rescheduleTumblrSubmission from '@/graphql/mutations/tumblr/rescheduleTumblrSubmission.gql'
import duplicateTumblrPost from '@/graphql/mutations/tumblr/duplicateTumblrPost.gql'
// Mastodon
import duplicateMastodonPost from '@/graphql/mutations/mastodon/duplicateMastodonPost.gql'
import deleteMastodonPost from '@/graphql/mutations/mastodon/deleteMastodonPost.gql'
import submitMastodonPost from '@/graphql/mutations/mastodon/submitMastodonPost.gql'
import bulkDeleteMastodonPosts from '@/graphql/mutations/mastodon/bulkDeleteMastodonPosts.gql'
import rescheduleMastodonPost from '@/graphql/mutations/mastodon/rescheduleMastodonPost.gql'

export const PLATFORM_CODE_REDDIT = 'reddit'
export const PLATFORM_CODE_TWITTER = 'twitter'
export const PLATFORM_CODE_INSTAGRAM = 'instagram'
export const PLATFORM_CODE_TIKTOK = 'tiktok'
export const PLATFORM_CODE_YOUTUBE = 'youtube'
export const PLATFORM_CODE_BLUESKY = 'bluesky'
export const PLATFORM_CODE_TUMBLR = 'tumblr'
export const PLATFORM_CODE_MASTODON = 'mastodon'

export const PLATFORM_NAME_REDDIT = 'Reddit'
export const PLATFORM_NAME_TWITTER = 'X / Twitter'
export const PLATFORM_NAME_INSTAGRAM = 'Instagram'
export const PLATFORM_NAME_TIKTOK = 'TikTok'
export const PLATFORM_NAME_YOUTUBE = 'YouTube'
export const PLATFORM_NAME_BLUESKY = 'Bluesky'
export const PLATFORM_NAME_TUMBLR = 'Tumblr'
export const PLATFORM_NAME_MASTODON = 'Mastodon'

export const platforms = [
  {
    code: PLATFORM_CODE_REDDIT,
    name: PLATFORM_NAME_REDDIT,
    icon: 'reddit',
    color: '#ff4500',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitRedditSubmission,
      submitPostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      deletePost: deleteRedditPostSubmission,
      deletePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      bulkDeletePosts: bulkDeleteRedditPostSubmissions,
      bulkDeletePostsVariables: (submissions) => {
        return { submissionIds: submissions.map((s) => s.id) }
      },
      reschedulePost: updateRedditPostSubmissionPostAt,
      reschedulePostVariables: (submission) => {
        return { id: submission.id }
      },
      duplicatePost: duplicateRedditPost
    }
  },
  {
    code: PLATFORM_CODE_TWITTER,
    name: PLATFORM_NAME_TWITTER,
    icon: 'square-x-twitter',
    color: '#000000',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      // Dashboard
      submitPost: submitTwitterPost,
      submitPostVariables: (submission) => {
        return { postId: submission.postId }
      },
      deletePost: deleteTwitterPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteTwitterPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleTwitterPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateTwitterPost,
      // History
      removeSubmissionFromPlatformMutation: deleteTwitterSubmission,
      cancelAutoRepostMutation: cancelAutoRetweet,
      cancelAutoRemoveMutation: cancelAutoRemove
    }
  },
  {
    code: PLATFORM_CODE_INSTAGRAM,
    name: PLATFORM_NAME_INSTAGRAM,
    icon: 'instagram',
    color: '#e1306c',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitInstagramSubmission,
      submitPostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      deletePost: deleteInstagramPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteInstagramPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleInstagramSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateInstagramPost
    }
  },
  {
    code: PLATFORM_CODE_TIKTOK,
    name: PLATFORM_NAME_TIKTOK,
    icon: 'tiktok',
    color: '#000000',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitTikTokSubmission,
      submitPostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      deletePost: deleteTikTokPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteTikTokPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleTikTokSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateTikTokPost
    }
  },
  {
    code: PLATFORM_CODE_YOUTUBE,
    name: PLATFORM_NAME_YOUTUBE,
    icon: 'youtube',
    color: '#FF0000',
    accountNoun: 'Channel',
    postNoun: 'Short',
    mutations: {
      submitPost: submitYouTubeSubmission,
      submitPostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      deletePost: deleteYouTubePost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteYouTubePosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleYouTubeSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateYouTubePost
    }
  },
  {
    code: PLATFORM_CODE_BLUESKY,
    name: PLATFORM_NAME_BLUESKY,
    icon: 'bluesky',
    color: '#0085FF',
    accountNoun: 'Account',
    postNoun: 'Post',
    mutations: {
      submitPost: submitBlueskyPost,
      submitPostVariables: (submission) => {
        return { postId: submission.postId }
      },
      deletePost: deleteBlueskyPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteBlueskyPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleBlueskyPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateBlueskyPost,
      removeSubmissionFromPlatformMutation: removeSubmissionFromBluesky,
      cancelAutoRepostMutation: cancelBlueskyAutoRepost,
      cancelAutoRemoveMutation: cancelBlueskyAutoRemove
    }
  },
  {
    code: PLATFORM_CODE_TUMBLR,
    name: PLATFORM_NAME_TUMBLR,
    icon: 'tumblr',
    color: '#001935',
    accountNoun: 'Blog',
    postNoun: 'Post',
    mutations: {
      submitPost: submitTumblrSubmission,
      submitPostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      deletePost: deleteTumblrPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteTumblrPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleTumblrSubmission,
      reschedulePostVariables: (submission) => {
        return { submissionId: submission.id }
      },
      duplicatePost: duplicateTumblrPost
    }
  },
  {
    code: PLATFORM_CODE_MASTODON,
    name: PLATFORM_NAME_MASTODON,
    icon: 'mastodon',
    color: '#6364ff',
    postNoun: 'Post',
    accountNoun: 'Account',
    mutations: {
      submitPost: submitMastodonPost,
      submitPostVariables: (submission) => {
        return { postId: submission.postId }
      },
      deletePost: deleteMastodonPost,
      deletePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      bulkDeletePosts: bulkDeleteMastodonPosts,
      bulkDeletePostsVariables: null,
      reschedulePost: rescheduleMastodonPost,
      reschedulePostVariables: (submission) => {
        return { postId: submission.postId }
      },
      duplicatePost: duplicateMastodonPost
    }
  }
]

/**
 * Platforms that are not Reddit. These all follow the same new pattern.
 */
export const newPlatforms = platforms.filter(
  (p) => p.code !== PLATFORM_CODE_REDDIT
)

export const platformCodes = platforms.map((platform) => platform.code)

export const newPlatformCodes = newPlatforms.map((platform) => platform.code)

export const platformNames = platforms.map((platform) => platform.name)

export function getPlatform(code) {
  return platforms.find(
    (platform) => platform.code === code.toLowerCase().trim()
  )
}

export function getPlatformName(code) {
  return getPlatform(code).name
}

export function getPlatformIcon(code) {
  return getPlatform(code).icon
}
